import { ESTADOS } from "#colaborador/Solicitudes/constants"
import { InputSelect } from "#common/input/InputSelect"
import { useApi } from "#hooks/useApi"
import Table from "#savings-fund/components/Table/Table"
import { SavingsFundProvider } from "#savings-fund/contexts/contexts"
import { savingsFundExcelGet, savingsFundStatusGet } from "#savings-fund/services/Api"
import { Box, Button, Paper, Skeleton, Stack } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { saveAs } from "file-saver"
import { useEffect, useState } from "react"

export default function SavingsFund() {
	ChangeTitle("Caja de Ahorro")
	const [status, setStatus] = useState(ESTADOS["REVISAR"])
	const [reload, setReload] = useState(false)

	return (
		<SavingsFundProvider {...{ reload, setReload }}>
			<Box
				component={Paper}
				sx={{ p: 2 }}
				display={"flex"}
				gap={2}
				flexDirection="column"
			>
				<Head {...{ status, setStatus }} />
				<Table opciones={status} size={11} />
			</Box>
		</SavingsFundProvider>
	)
}
const Head = ({ status, setStatus }) => {
	const { loading, data } = useApi(savingsFundStatusGet, {
		autoFetch: true,
	})

	const { fetch, data: excel } = useApi(savingsFundExcelGet, {
		autoFetch: false,
		responseAll: true,
	})

	useEffect(() => {
		if (excel) saveAs(excel, `caja_ahorro_${new Date().toISOString()}.xlsx`)
	}, [excel])

	if (loading) return <Skeleton variant="rectangular" height={"10vh"} />

	return (
		<Stack direction="row-reverse" spacing={2} justifyContent="center">
			<InputSelect
				label="Seleccionar opción"
				dataId="id"
				dataLabel="name"
				data={data?.status}
				value={status}
				setValue={setStatus}
				fullWidth={false}
				formControlProps={{ sx: { minWidth: "300px" } }}
			/>
			<Button onClick={() => fetch()}>Descargar Calculo</Button>
		</Stack>
	)
}
